import { gql } from '@biletiniz/apollo';

export const LOGIN = gql`
mutation login($username: String!, $password: String!){
  login(username: $username, password:$password) {
    message
    session
    status
    token {
      accessToken
      accessTokenExpiresAt
      refreshToken
      refreshTokenExpiresAt
      user {
        name
        surname
        email
        phoneNumber
        balance {
          amount
          currency
        }
      }
    }
  }
}
`;